import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "border-t border-gray-100 pt-5"
}
const _hoisted_4 = { class: "flex items-center justify-between gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-6 border-t border-gray-100 pt-5"
}

import { computed, inject, onMounted, ref } from 'vue'

import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue'
import InputArea from '@/components/neue/InputArea'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'

// TODO(alicja): make toggles immediate?


export default {
  __name: 'StoreReceipt',
  props: ['id', 'only'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props

// The page shows one of these two at a time, so it says which.
const shows = part => !props.only || props.only === part
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const automation = computed(() => mapRelationship(store.value?.relationships.paid_bottle_message_automation.data))
const template = computed(() => mapRelationship(automation.value?.relationships.message_template.data))

const show = ref(false)
const text = ref('')
const automationEnabled = ref(false)
const message = ref('')

const existingImages = computed(() =>
  mapRelationships(
    mapRelationship(automation.value?.relationships.message_template.data)?.relationships.attachments.data
  )
)

const load = () => {
  show.value = store.value.attributes.show_receipt_text
  text.value = store.value.attributes.receipt_page_text
  automationEnabled.value = automation.value?.attributes.turned_on
  message.value = template.value?.attributes.body
}

onMounted(async () => {
  await api.call(
    'GET',
    `stores/${props.id}?included=paid_bottle_message_automation,paid_bottle_message_automation.message_template,paid_bottle_message_automation.message_template.attachments`
  )
  loading.value = false
  load()
})

const dirty = () => bus.emit('dirty/store', { from: 'receipt' })

const changeImages = images => {
  api.call(
    'PUT',
    `stores/${props.id}?included=paid_bottle_message_automation,paid_bottle_message_automation.message_template,paid_bottle_message_automation.message_template.attachments`,
    {
      store: {
        paid_bottle_message_automation_attributes: {
          id: automation.value?.id,
          message_template_attributes: {
            id: template.value?.id,
            attachments_attributes: images
          }
        }
      }
    }
  )
}

bus.on('save/store', () => {
  api.call(
    'PUT',
    `stores/${props.id}?included=paid_bottle_message_automation,paid_bottle_message_automation.message_template,paid_bottle_message_automation.message_template.attachments`,
    {
      store: {
        receipt_page_text: text.value,
        show_receipt_text: show.value,
        paid_bottle_message_automation_attributes: {
          id: automation.value?.id,
          turned_on: automationEnabled.value,
          message_template_attributes: {
            id: template.value?.id,
            body: message.value
          }
        }
      }
    }
  )
})

bus.on('discard/store', load)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (shows('settings'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 0,
              title: "Receipt message",
              description: "A note shown on the receipt page once a customer has placed an order. Good for pickup instructions or a thank you."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "min-w-0" }, [
                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Show a message on the receipt page"),
                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " The message below appears once this is on. Off leaves the receipt page as it is. ")
                  ], -1)),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: show.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((show).value = $event)),
                    onChange: dirty
                  }, null, 8, ["modelValue"])
                ]),
                (show.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(InputArea), {
                        modelValue: text.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((text).value = $event)),
                        name: "Receipt page text",
                        onInput: dirty
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (shows('automation'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 1,
              title: "Paid order reply",
              description: "Sent to the customer once their order is paid."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "min-w-0" }, [
                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Reply when an order is paid"),
                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means no message is sent.")
                  ], -1)),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: automationEnabled.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((automationEnabled).value = $event)),
                    onChange: dirty
                  }, null, 8, ["modelValue"])
                ]),
                (automationEnabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(InputArea), {
                        modelValue: message.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((message).value = $event)),
                        name: "Message",
                        onInput: dirty
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(ImageUploaderNeue), {
                        files: existingImages.value,
                        editable: true,
                        "display-multiple": false,
                        "max-file-size": 2 * 1024 * 1024,
                        onChange: changeImages
                      }, null, 8, ["files"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}